import { Building2, Plus, Mail, Phone, LogOut } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useUserRole } from "@/hooks/useUserRole";
import { useAuth } from "@/hooks/useAuth";
import { useCallback } from "react";

interface NoOrganizationStateProps {
  isAdmin?: boolean;
}

export function NoOrganizationState({ isAdmin: propIsAdmin }: NoOrganizationStateProps) {
  const navigate = useNavigate();
  const { isAdmin: hookIsAdmin } = useUserRole();
  const { user, signOut } = useAuth();
  const isAdmin = propIsAdmin ?? hookIsAdmin;

  const handleLogout = useCallback(async () => {
    await signOut();
    navigate('/auth');
  }, [signOut, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8">
          <div className="text-center space-y-6">
            <div className="mx-auto w-16 h-16 rounded-full bg-muted flex items-center justify-center">
              <Building2 className="h-8 w-8 text-muted-foreground" />
            </div>
            
            <div className="space-y-2">
              <h2 className="text-2xl font-semibold">Nenhuma Organização</h2>
              <p className="text-muted-foreground">
                {isAdmin 
                  ? 'Você precisa criar uma organização para começar a usar o sistema.'
                  : 'Você não está vinculado a nenhuma organização.'}
              </p>
            </div>

            {user && (
              <div className="text-sm text-muted-foreground bg-muted/50 rounded-lg p-3">
                <p>Logado como:</p>
                <p className="font-medium text-foreground">{user.email}</p>
              </div>
            )}

            {isAdmin ? (
              <Button onClick={() => navigate('/admin')} className="w-full">
                <Plus className="mr-2 h-4 w-4" />
                Criar Organização
              </Button>
            ) : (
              <div className="space-y-4">
                <p className="text-sm text-muted-foreground">
                  Entre em contato com o administrador para solicitar acesso:
                </p>
                <div className="flex flex-col gap-2">
                  <a 
                    href="mailto:suporte@jnrmarketingdigital.com.br" 
                    className="inline-flex items-center justify-center gap-2 text-sm text-primary hover:underline"
                  >
                    <Mail className="h-4 w-4" />
                    suporte@jnrmarketingdigital.com.br
                  </a>
                  <a 
                    href="https://wa.me/5511999999999" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 text-sm text-primary hover:underline"
                  >
                    <Phone className="h-4 w-4" />
                    WhatsApp
                  </a>
                </div>
              </div>
            )}

            <Button 
              variant="outline" 
              onClick={handleLogout} 
              className="w-full mt-4"
            >
              <LogOut className="mr-2 h-4 w-4" />
              Sair e trocar de conta
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
